"use client";

import VERTICAL_OPTIONS from "@/constants/VerticalOptions";
import { Box, Typography } from "@mui/material";
import Link from "next/link";
import OptionsLinkSection from "./OptionsLinkSection";
import BREED_OPTIONS from "@/constants/BreedOptions";
import DISCIPLINE_OPTIONS from "@/constants/DisciplineOptions";
import { BoxWithGutters } from "../common/BoxWithGutters";
import PillButton from "@/app/shared/PillButton";
import { NAV_SELECTED_BACKGROUND_COLOR } from "@/app/layout/LayoutConstants";

export default function HomepageLinksSection() {
  return (
    <BoxWithGutters
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 6,
        paddingTop: 4,
        paddingBottom: 4,
        justifySelf: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Typography variant="h5" component="h2">
          Browse by Category
        </Typography>
        <Box
          sx={{
            display: "flex",
            gap: 2,
            flexWrap: "wrap",
            maxWidth: "1100px",
            margin: "0 auto",
            a: {
              display: "flex",
              alignItems: "stretch",
              justifyContent: "center",
            },
          }}
        >
          {VERTICAL_OPTIONS.filter((x) => x).map((vertical) => (
            <Link key={vertical.id} href={`/for-sale/${vertical.slug}`}>
              <PillButton
                sx={{
                  backgroundColor: NAV_SELECTED_BACKGROUND_COLOR,
                  fontWeight: "bold",
                }}
              >
                {vertical.label}
              </PillButton>
            </Link>
          ))}
        </Box>
      </Box>

      <Box
        sx={(theme) => ({
          display: "flex",
          gap: 8,
          maxWidth: "1100px",
          margin: "0 auto",
          [theme.breakpoints.down("md")]: {
            flexDirection: "column",
            gap: 2,
          },
        })}
      >
        <OptionsLinkSection title="Breeds" options={BREED_OPTIONS} />
        <OptionsLinkSection title="Disciplines" options={DISCIPLINE_OPTIONS} />
      </Box>
    </BoxWithGutters>
  );
}
